import { StringUtil } from './string.util'
import { ReceiptItem } from './receipt-item'
import { ReceiptInfo } from './receipt-info'
import { ReceiptPrototype } from './receipt.prototype'

const DATE_PAT = (() => {
  try {
    return new RegExp('\(?<!\\d)\\d{1,2}\\/\\d{1,2}\\/\\d{2,4}(?!\\d)')
  } catch (e) {
    console.error(e)
    return /\d{1,2}\/\d{1,2}\/\d{2,4}/
  }
})

export class CoachOutletReceipt extends ReceiptPrototype {

  private static readonly CreditPat = /\(\$\d{1,}\.?\d{0,}\)/

  constructor(text: string = null, private tools = new StringUtil()) {
    super()
    if (text) {
      this.process(text)
    }
  }

  process(text: string): void {
    const lines = this.tools.getCleanLines(text), items = []
    this.items = this.getItemBlocks(lines).map(x => this.processItemBlock(x)).filter(Boolean)
    this.info = this.processInfo(lines)
    this.items.forEach(x => x.tax_rate = x.taxed ? this.info.tax_rate : 0)
  }

  private processInfo(lines: string[]): ReceiptInfo {
    let date = null, purchaser = '', subtotal = 0, tax = 0
    const match = []
    lines.forEach((x, i) => {
      if (x.indexOf('customer:') >= 0) {
        purchaser = x.slice('customer:'.length + 1)
      }
      if (x.indexOf('subtotal') >= 0 && !subtotal) {
        subtotal = this.tools.firstNumberOfString(x)
      }
      if (x.indexOf('tax') >= 0 && !tax) {
        tax = this.tools.lastNumberOfString(x)
      }
      const matches = x.match(DATE_PAT())
      if (matches && !date) {
        date = new Date(x.match(DATE_PAT())[0]).toISOString().slice(0, 10)
      }
    })
    return new ReceiptInfo({
      subtotal,
      tax,
      date: date ? date : new Date().toISOString().slice(0, 10),
      purchaser
    })
  }

  private getItemBlocks(lines: string[]): string[][] {
    let start = 0, line = ''
    const blocks: string[][] = []
    for (let i = 0; i < lines.length; i ++) {
      line = lines[i]
      if (line.match(this.barcodePattern) && line.match(this.barcodePattern).length === 1) {
        if (start > 0) {
          blocks.push(lines.slice(start - 1, i - 1))
        }
        start = i
      } else if (start > 0 && line.indexOf('total') >= 0) {
        blocks.push(lines.slice(start - 1, i - 1))
        break
      }
    }
    return blocks
  }

  private processItemBlock(lines: string[]): ReceiptItem {
    if (CoachOutletReceipt.CreditPat.test(lines[0])) {
      return null
    }
    let style = '', color = '', name = '', count = 0, pre_tax_price = 0
    let line = lines[2]
    const pat = /\w+\s\w+\s\d+\s@\s\$\d+.*/
    if (pat.test(line)) {
      const m = line.match(/\d+\s+@/)
      let c = ''
      if (m) {
        c = m[0].split(' ')[0]
        line = line.slice(0, m.index);
        [style, color] = line.split(' ')
      }
      count = Number(c)
    } else {
      const bits = lines[2].split(' ')
      let breaker = 0
      // locate where @ symbol is
      bits.forEach((bit, index) => {
        if (bit.match(this.stylePattern)) {
          style = bit
        } else if (bit.localeCompare('@') === 0) {
          breaker = index
        }
      })

      // obtain count and color in the same line
      count = Number(bits[breaker - 1])
      for (let j = 1; j < breaker - 1; j ++) {
        if (j < breaker - 2) {
          color += bits[j]
          color += '-'
        } else {
          color += bits[j]
        }
      }
    }

    pre_tax_price = Math.round(this.tools.lastNumberOfString(lines[0]) / count * 100) / 100

    const startLine = lines[0]
    const newBits = startLine.split(' ')
    const end = startLine.indexOf(';') > 0 ? startLine.indexOf(';') : startLine.indexOf('$')
    name = startLine.slice(0, end).replace(/\s$/, '')
    return new ReceiptItem({
      barcode: lines[1],
      brand: 'coach',
      category: '包袋',
      name: `${style} ${color} - ${name}`,
      pre_tax_price,
      count,
      taxed: lines[0][lines[0].length - 1] !== 'n',
      shipped: lines[0][lines[0].length - 1] === 'd'
    })
  }

  get stylePattern() {
    return /f?\d{5}/
  }

  get barcodePattern() {
    return /^\d{12}/
  }

}




// WEBPACK FOOTER //
// ./src/app/models/text-receipt/coach-outlet-receipt.ts